<template>
    <v-dialog v-model="dialog" persistent max-width="500px">
        <v-card flat outlined rounded v-if="dialog">
            <v-card-title class="text-h6 justify-center">
                <span class="body-font-family gray--text text--darken-5">{{ $t('Delete quest?') }}</span>
            </v-card-title>
            <v-divider class="my-3" />
            <v-card-text>
                <div class="title text-center">
                    {{ $t('Do you really want to delete this quest?') }}
                </div>
            </v-card-text>
            <v-card-actions>
                <v-btn class="primary" depressed :disabled="disabled" @click="onQuestDelete">
                    {{ $t('Delete') }}
                </v-btn>
                <v-spacer />
                <v-btn color="primary--text" x-large depressed :disabled="disabled" @click="dialog = false">
                    {{ $t('Cancel') }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapActions } from 'vuex';
import { ActivityModel } from '../models';

export default {
    props: {
        value: {
            type: Boolean,
        },
        quests: {
            type: Array,
        },
    },
    data() {
        return {
            disabled: false,
        };
    },
    computed: {
        dialog: {
            set(val) {
                this.$emit('input', val);
            },
            get() {
                return this.value;
            },
        },
    },
    methods: {
        ...mapActions('questList', ['deleteQuest']),
        onQuestDelete() {
            this.disabled = true;
            const promises = [];
            this.quests.forEach(questId => {
                promises.push(this.deleteQuest(questId));
            });
            Promise.allSettled(promises).then(() => {
                this.dialog = false;
                this.disabled = false;
                this.$emit('quests-deleted', this.quests);
            });
        },
    },
};
</script>
